export const ROWS_PER_PAGE_OPTIONS = [10, 20, 50, 100]

export const DEFAULT_PAGE = 1
export const DEFAULT_PER_PAGE = 10
